import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { FC, useState } from 'react';

export const useShareholderDetailModal = () => {
	// Can pass data instead of id, depending on the need
	const [modalData, setModalData] = useState<string>();

	return {
		isOpen: !!modalData,
		open: (id: string) => setModalData(id),
		close: () => setModalData(undefined),
	};
};

const ShareholderDetailModal: FC<
	ReturnType<typeof useShareholderDetailModal>
> = (props) => {
	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			closable={true}
			buttonPosition="end"
			okButtonProps={{
				hidden: true,
			}}
			cancelText="BACK"
			onCancel={() => props.close()}
		>
			<FleetTitle>View Susunan Pemegang Saham</FleetTitle>
			<div
				style={{
					marginTop: 12,
					marginBottom: 12,
					fontWeight: 700,
				}}
			>
				Berdasarkan Akta Perubahan Pengurus dan Pemegang Saham Terakhir
			</div>

			<DataRow
				items={[
					[
						['Nomor', '000-000-000'],
						['Tahun', '2023'],
					],
					[
						['Nama', 'Dodo Prasetya'],
						['Tipe Pemegang Saham', 'Pemilik'],
					],
					[
						['Kewarganegaraan', 'WNI'],
						['Nationality', 'Indonesia'],
					],
					[
						['Jenis Identitas', '12345678012345'],
						['No. ID', '12345678012345'],
					],
					[['View Identitas', 'KTP-DODO.PNG']],
					[
						['Alamat', 'Jl. M.H. Thamrin No. 23 Jakarta Pusat'],
						['RT/RW', '007/008'],
					],
					[
						['Kode Pos', '10112'],
						['Kelurahan', 'Gambir'],
					],
					[
						['Kecamatan', 'Gambir'],
						['Kota', 'Jakarta Pusat'],
					],
					[
						['No. Telepon', '087845367892'],
						['Kepemilikan Saham', '40%'],
					],
					[['Status', 'Aktif']],
				]}
				style={{
					marginBottom: 20,
				}}
			/>
		</FleetModal>
	);
};

export default ShareholderDetailModal;
